import Vue from "vue";
import Paginate from "vuejs-paginate/src/components/Paginate.vue";
import "./pagination.less";
Vue.component("Paginate", Paginate);
